module.exports = __webpack_public_path__ + "static/media/7news.a87b19ac.png";